// extracted by mini-css-extract-plugin
module.exports = {"zodiacWrapper":"zodiac-comp_zodiacWrapper__ou_Wi","formWrapper":"zodiac-comp_formWrapper__imGhv","buttonWrapper":"zodiac-comp_buttonWrapper__0shaK"};